import { createTheme } from '@material-ui/core/styles';
import colors from './colors';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.secondary,
    },
    secondary: {
      main: colors.primary,
    },
    text: {
      main: '#fff',
    },
  },
});

export default theme;
